/* eslint-disable react/jsx-one-expression-per-line */
import { QuestionComponentProps } from '../../type';

const FillInTheBlank_Results = ({ questionIndex, questionData, isCombineChild }: QuestionComponentProps) => {
  const { answers, audioUrl } = questionData;
  return (
    <div style={{ display: 'flex', gap: 5 }}>
      <div>{isCombineChild ? <i>{questionIndex + 1}.</i> : <span>{questionIndex + 1}.</span>}</div>
      <div>
        <div>
          Answer:
          {Array.isArray(answers) && answers?.map((answer) => <>&emsp; {answer.answer},</>)}
        </div>
        {audioUrl ? <div>Audio: {audioUrl}</div> : null}
      </div>
    </div>
  );
};

export default FillInTheBlank_Results;
